function reducer(state = [], action) {
    switch (action.type) {
        case 'TEAM/VIDEO/SET':
            return action.video;
        case 'VIDEO/SET':
            return action.video;
        default:
            return state;
    }
}

export default reducer;